export class Trophie {
    id: number;
    country: string;
    count: number;
    playerId: number;
    leagueName: string;
    seasons: string;
    ranking: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/trophie.model.ts